import { Injectable } from '@angular/core';
import { identity, pickBy } from 'lodash';
import { Observable } from 'rxjs';
import {
  ACCEPT_VERSION_HEADER,
  AuthHttpService,
} from '../auth-data/auth-http.service';
import {
  EXPENSE_REPORT_EXPORT_ACCEPT_VERSION,
  EXPORT_ACCEPT_VERSION,
  ExportTypesEnum,
} from './export-data.data';

@Injectable()
export class ExportDataService {
  constructor(private _authHttpService: AuthHttpService) {}

  /**
   * Export data for given export type
   * @see https://qa-export-api.invoice2go.io/docs/#!/exports/post_exports_expense_report
   * @param type
   * @param userEmail
   * @param companyName
   */
  exportData(
    type: ExportTypesEnum,
    userEmail: string,
    companyName: string
  ): Observable<any> {
    const headers = {
      [ACCEPT_VERSION_HEADER]: EXPORT_ACCEPT_VERSION,
    };
    const requestBody = pickBy(
      {
        mail: {
          recipient: userEmail,
          company_name: companyName,
        },
        type,
      },
      identity
    );

    return this._authHttpService.post(
      '/exports',
      requestBody,
      headers,
      true,
      'text'
    );
  }

  /**
   * Export expense report
   * @see https://qa-export-api.invoice2go.io/docs/#!/exports/post_exports_expense_report
   */
  exportExpenseReport(userEmail: string, taxYear: number): Observable<any> {
    const headers = {
      [ACCEPT_VERSION_HEADER]: EXPENSE_REPORT_EXPORT_ACCEPT_VERSION,
    };
    const requestBody = {
      mail: {
        recipient: userEmail,
      },
      tax_year: taxYear,
    };

    return this._authHttpService.post(
      '/exports/expense_report',
      requestBody,
      headers,
      true,
      'text'
    );
  }
}
